import { LinkedBrokersBlockedAction } from "../../../utils/types";

export const BLOCKED_LABELS: Record<LinkedBrokersBlockedAction, string> = {
  delete: "Deletion blocked",
  deactivate: "Deactivation blocked",
};
